import { render } from "./mvt-emaillogin.vue?vue&type=template&id=8e4c1fc6"
import script from "./mvt-emaillogin.js?vue&type=script&lang=js"
export * from "./mvt-emaillogin.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__